<nz-upload
  class="file-upload"
  nzName="file"
  [nzAccept]="fileTypes"
  [nzFileList]="fileList"
  [nzFileListRender]="fileListRender"
  [nzMultiple]="allowMultiple"
  [nzLimit]="uploadLimit"
  [nzSize]="fileSizeLimit"
  [nzBeforeUpload]="beforeUpload"
  [nzDisabled]="disable"
  [nzRemove]="remove"
  >
  <button
    #button
    nz-button
    type="button"
    [nzDanger]="danger"
    [disabled]="disable"
  >
    <i class="fa-l fas fa-upload"></i>
    <span class="button-upload-label">
      {{ label | translate }}
    </span>
  </button>
  <span class="hint" *ngIf="allowFilesLabel">
    {{ allowFilesLabel | translate }}
  </span>
</nz-upload>
